Vendd.Scripts.load(function () {

	var $wrapper = $('.x-category-list');

	if ($wrapper.length < 1)
		return;

});